import { useContext } from 'react';

import {
  PageDelimitationScaleContext,
  PageDelimiterContentHeightContext,
} from './page-delimitation-scale.context';

export function usePageDelimitationScale(): number {
  return useContext(PageDelimitationScaleContext);
}

export function usePageDelimiterContentHeight(): number | null {
  return useContext(PageDelimiterContentHeightContext);
}
